export const baseModalTitles = {
  baseModalTitleProfileUser: "Profile User",
  baseModalTitleMobilePayment: "Top Up",
  baseModalTitleInviteFriend: "Invite Friend",
  baseModalTitleChangePassword: "Change Password",
  baseModalTitleWithdrawal: "Withdrawal",
  baseModalTitleTransfer: "Transfer Money",
  baseModalTitleRegistration: "Sign Up and Win!",
  baseModalTitleSupport: "Support",
};
